(() => {
  const init = root => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const search = root.querySelector('[data-eds-hub-search]');
    const filters = [...root.querySelectorAll('[data-group]')];
    const groups = [...root.querySelectorAll('[data-eds-hub-group]')];
    const cards = [...root.querySelectorAll('[data-eds-hub-card]')];
    const featuredCards = cards.filter(card => card.closest('.eds-hub__featured'));
    const empty = root.querySelector('[data-eds-hub-empty]');
    const status = root.querySelector('[data-eds-hub-status]');
    const availableGroups = new Set(groups.map(group => group.dataset.edsHubGroup));
    const cardKey = card => card.getAttribute('href') || card.dataset.edsHubTitle || '';

    filters.forEach(button => {
      if (button.dataset.group !== 'all' && !availableGroups.has(button.dataset.group)) button.hidden = true;
    });

    let active = 'all';

    const update = () => {
      const query = (search?.value || '').trim().toLowerCase();
      const visibleKeys = new Set();

      groups.forEach(group => {
        const groupMatch = active === 'all' || group.dataset.edsHubGroup === active;
        let visible = 0;

        group.querySelectorAll('[data-eds-hub-card]').forEach(card => {
          const title = (card.dataset.edsHubTitle || '').toLowerCase();
          const match = groupMatch && title.includes(query);
          card.hidden = !match;

          if (match) {
            visible++;
            visibleKeys.add(cardKey(card));
          }
        });

        group.hidden = visible === 0;
      });

      featuredCards.forEach(card => {
        const title = (card.dataset.edsHubTitle || '').toLowerCase();
        const show = active === 'all' && title.includes(query);
        card.hidden = !show;
        if (show) visibleKeys.add(cardKey(card));
      });

      const total = visibleKeys.size;
      empty?.classList.toggle('is-visible', total === 0);
      if (status) status.textContent = `${total} ${total === 1 ? root.dataset.singular : root.dataset.plural}`;
    };

    search?.addEventListener('input', update);
    search?.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !search.value) return;
      search.value = '';
      update();
    });

    filters.forEach(button => button.addEventListener('click', () => {
      active = button.dataset.group;
      filters.forEach(item => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
      update();
    }));

    update();
  };

  const initAll = scope => scope.querySelectorAll('[data-eds-hub]').forEach(init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);

  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
